import { render, staticRenderFns } from "./viewDetail.vue?vue&type=template&id=0b18c2e2&scoped=true&"
import script from "./viewDetail.vue?vue&type=script&lang=js&"
export * from "./viewDetail.vue?vue&type=script&lang=js&"
import style0 from "./viewDetail.vue?vue&type=style&index=0&id=0b18c2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b18c2e2",
  null
  
)

export default component.exports